import { http, results } from './client';

/** Updates profile fields; returns the updated user (without token). */
export const updateProfile = ({ email, firstname, lastname, phone }) =>
  http.post('api/v1/user', { email, firstname, lastname, phone }).then(results);

/**
 * { status: 'not_applied' | 'pending_review' | 'denied' | 'suspended' | 'active_host',
 *   isHost, hostRequestedAt, hostDenialReason, hostSuspensionType, ... }
 */
export const getHostStatus = () => http.get('api/v1/user/host-status').then(results);

export const requestHostAccess = () => http.post('api/v1/user/become-host').then((r) => r.data);
